export const FILTER_OPTIONS = [
  { value: false, label: 'Open' },
  { value: true, label: 'Resolved' },
];

export const ALL_STATUSES = [true, false];
